import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Store } from '@ngrx/store';
import { AccountComponent } from 'account/components/account/account.component';
import { ProfileInfoComponent } from 'account/pages/profile-info/components/profile-info/profile-info.component';
import { loggedUser } from 'app/store/login/logged-user/logged-user.selectors';
import { AuthGuard } from 'core/guards/auth.guard';
import { UserOutput, UserService } from 'core/http/root';
import { selectFirst } from 'core/utils/rx-common';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserResolver {
  constructor(
    private store$: Store,
    private userService: UserService,
  ) {}

  resolve(): Observable<UserOutput> {
    return this.store$.pipe(
      selectFirst(loggedUser),
      switchMap((token) => {
        if (!token) {
          return of({} as UserOutput);
        }

        return this.userService.getUser(token.userInfo.id);
      }),
    );
  }
}

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: AccountComponent,
    children: [
      {
        path: '',
        redirectTo: 'profile-info',
        pathMatch: 'full',
      },
      {
        path: 'profile-info',
        component: ProfileInfoComponent,
        data: { title: 'PAGE_TITLES.profile' },
        resolve: {
          user: UserResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {
}
